<template>
	<div v-if="showModal">
		<teleport to="#mediacontent-modal">
			<transition name="modal">
				<div class="modal-mask modal">
					<div class="modal-wrapper" @click="showModal = false">
						<div class="modal-dialog modal-lg">
							<div class="modal-content" id="media-modal-content" @click.stop>
								<div class="modal-header">
									<div class="col-lg-12 dynvibeTitleBox dynvibeTitleModal">
										<h5 class="modal-title">
											MEDIA CONTENT
											<button type="button" class="close" @click="showModal = false">
												<span aria-hidden="true">
													<i class="icon-x"></i>
												</span>
											</button>
										</h5>
									</div>
								</div>
								<div class="modal-body">
									<div
										v-if="modalHues.length > 0 || modalBrands.length > 0 || modalObjects.length > 0"
										class="dynvibeBox"
									>
										<div class="row dynvibeRow" style="margin-top: 15px; margin-bottom: 20px">
											<div
												class="col-lg-12"
												v-if="(modalType === 'colors' || fromPage === 'moodboard') && modalHues.length > 0"
												style="margin-bottom: 20px"
											>
												<div class="col-xs-2">
													<label class="control-label">Select a color</label>
													<br />
													<button class="reset-color" @click="resetTableColor('color')">Reset</button>
												</div>
												<div class="col-xs-10">
													<table id="hue-table">
														<tr>
															<td v-for="(value, index) in modalHues" :key="index">
																{{ value["doc_count"] }}
															</td>
														</tr>
														<tr>
															<td
																v-for="(value, index) in modalHues"
																:style="hueStyle(value)"
																@click="colorClicked(value, 'hue')"
																:key="index"
															></td>
														</tr>
													</table>
													<table id="subhue-table">
														<tr>
															<td
																v-for="(subvalue, index) in modalSubHues"
																:style="hueStyle(subvalue)"
																@click="colorClicked(subvalue, 'subhue')"
																:key="index"
															></td>
														</tr>
														<tr>
															<td v-for="(subvalue, index) in modalSubHues" :key="index">
																{{ subvalue["doc_count"] }}
															</td>
														</tr>
													</table>
												</div>
											</div>
											<div
												class="col-lg-12 dynvibeSearch"
												v-if="
													(modalType === 'objects' || fromPage === 'moodboard') &&
													(modalBrands.length > 0 || modalObjects.length > 0)
												"
											>
												<div class="col-xs-2">
													<label class="control-label">Select a category</label>
													<br />
													<button class="reset-color" @click="resetTableColor('object')">Reset</button>
												</div>
												<div id="dynvibeSearchFiltersBase" class="col-xs-6">
													<div class="col-xs-6">
														<select
															class="listSort dynvibeListSort"
															name="brand"
															data-type="brand"
															@change="onChangeBrands"
														>
															<option value="">Choose a brand</option>
															<option v-for="brand in modalBrands" :key="brand.key" :value="brand.key">
																{{ brand.key }} ({{ brand.doc_count }})
															</option>
														</select>
														<div
															@click="clickOnArianeBrands(selectedBrand)"
															class="menuArianeBrand menuAriane"
															v-for="(selectedBrand, index) in selectedBrands"
															:key="index"
														>
															<span class="menuArianeValue">{{ selectedBrand }}</span> <i class="icon-x"></i>
														</div>
													</div>
													<div class="col-xs-6">
														<select
															class="listSort dynvibeListSort"
															name="object"
															data-type="object"
															@change="onChangeObjects"
														>
															<option value="">Choose an object</option>
															<option v-for="object in modalObjects" :key="object.key" :value="object.key">
																{{ object.key }} ({{ object.doc_count }})
															</option>
														</select>
														<div
															@click="clickOnArianeObjects(selectedObject)"
															class="menuArianeObject menuAriane"
															v-for="(selectedObject, index) in selectedObjects"
															:key="index"
														>
															<span class="menuArianeValue">{{ selectedObject }}</span> <i class="icon-x"></i>
														</div>
													</div>
												</div>
												<div class="col-xs-4" v-if="fromPage === 'moodboard'">
													<div class="col-xs-6">
														<label class="control-label">Group by</label>
														<div class="dynvibeInputRadio">
															<input type="radio" v-model="groupBy" id="medias-checkbox" value="medias" />
															<label class="radio-inline" for="medias-checkbox"> Photos </label><br />
															<input type="radio" v-model="groupBy" id="user-checkbox" value="user" />
															<label class="radio-inline" for="user-checkbox"> User </label>
														</div>
													</div>
													<div class="col-xs-6" v-if="groupBy === 'user'">
														<div>
															<label class="control-label">Nb photos</label><br />
															<select v-model="nbPhotosProfiles" class="form-control dynvibeSelect">
																<option value="5">5</option>
																<option value="10">10</option>
																<option value="20">20</option>
																<option value="50">50</option>
															</select>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div v-if="contentLoading" class="dynvibeLoading" style="min-height: 90px"></div>
									<div v-else-if="modalMedias.length === 0" class="noData"><p>No Data to display</p></div>
									<div v-else class="row dynvibeRow mediasContent">
										<div class="row dynvibeRow" v-if="groupBy === 'medias'">
											<div class="col-lg-12">
												<ul class="dynvibeGalleryMedias">
													<li
														v-for="media in modalMedias"
														:key="getMediaId(media)"
														aria-hidden="false"
														class="filterMedia"
													>
														<a :href="getMediaUrl(media)" target="_blank" :style="getMediaStyle(media)">
															<span class="dynvibeGalleryMediasFilter"></span>
															<span class="dynvibeGalleryPopularMediasHover" v-if="fromPage === 'posts'">
																<button
																	v-on:click.stop.prevent="addMedia(media, $event)"
																	class="pull-right btn btn-success btn-display"
																>
																	+
																</button>
																<button
																	v-on:click.stop.prevent="removeMedia(media, $event)"
																	class="pull-right btn btn-danger"
																>
																	-
																</button>
																<span class="icon-select-image"></span>
																{{ getMediaContent(media) }}
															</span>
														</a>
													</li>
												</ul>
											</div>
										</div>
										<div class="row dynvibeRow" v-if="groupBy === 'user'">
											<div class="col-lg-12 mediasByAuthor" v-for="(profile, index) in modalMedias" :key="index">
												<div class="col-lg-12">
													<span class="dynvibeStoryInfoUsername">
														{{ getName(profile) }}
													</span>
													<button class="dynvibeButton" v-on:click="toggleHideProfile(profile)">
														Hide / Show
													</button>
												</div>
												<div>
													<ul
														class="dynvibeGalleryMedias"
														v-show="hiddenProfile.length === 0 || hiddenProfile.indexOf(profile['key']) < 0"
													>
														<li
															v-for="(picture, index) in profile['pictures']['buckets']"
															aria-hidden="false"
															class="filterMedia"
															:key="index"
														>
															<a :href="getMediaUrl(picture)" target="_blank" :style="getMediaStyle(picture)">
																<span class="dynvibeGalleryMediasFilter"></span>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="modal-footer" v-if="fromPage === 'posts'">
									<div class="col-xs-12">
										<div class="dynvibeBox" style="min-height: 90px">
											<div class="col-xs-3 dynvibeModalPostsActions">
												<div>
													<select
														v-model="catSelected"
														id="dynvibeListCategoriesPostsAction"
														class="listMastertag dynvibeListCategories dynvibeModalPostInput"
														@change="listCatPosts($event, 'cat')"
													>
														<option value>Categories</option>
														<option v-for="category in catsList" :key="category" :value="category">
															{{ category }}
														</option>
													</select>
													<select
														v-model="subcatSelected"
														id="dynvibeListSubcategoriesPostsAction"
														class="listMastertag dynvibeListSubcategories dynvibeModalPostInput"
														@change="listCatPosts($event, 'subcat')"
													>
														<option value>Subcategories</option>
														<option v-for="subcategory in subcatsList" :key="subcategory" :value="subcategory">
															{{ subcategory }}
														</option>
													</select>
													<select
														v-model="mastertagSelected"
														id="dynvibeListMastertagsPostsAction"
														class="listMastertag dynvibeListMastertags dynvibeModalPostInput"
													>
														<option value>Mastertags</option>
														<option v-for="mastertag in mastertagsList" :key="mastertag" :value="mastertag">
															{{ mastertag }}
														</option>
													</select>
												</div>
											</div>
											<div class="col-xs-4 dynvibeModalPostsActions dynvibeModalPostsActionsAdd">
												<div
													@click="removeMastertagToAdd(mastertag)"
													class="menuMastertagToAdd menuAriane menuArianeAdd"
													v-for="(mastertag, index) in mastertagsToAdd"
													:key="index"
												>
													<span class="menuMastertagValue">{{ mastertag }}</span> <i class="icon-x"></i>
												</div>
											</div>
											<div class="col-xs-4 dynvibeModalPostsActions">
												<p>Mastertags in selected stories</p>
												<br />
												<div class="dynvibeModalMastertagsDelete" v-if="Object.keys(postsByMastertag).length !== 0">
													<div
														class="dynvibeModalMastertagDelete"
														v-for="index in postsByMastertag"
														:key="index"
														@click="selectMastertagsToRemove(index, $event)"
													>
														<span>{{ index }}</span>
													</div>
												</div>
											</div>
											<div class="col-xs-1 dynvibeModalPostsActions">
												<button class="btn-success dynvibeModalPostsActionsFooterBtn" @click="saveMassiveImages()">
													Add
												</button>
												<button class="btn-danger dynvibeModalPostsActionsFooterBtn" @click="removeMassiveImages()">
													Delete
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</teleport>
	</div>
	<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType">
		<template v-slot:confirm-body>{{ confirmMessage }}</template>
	</confirm>
</template>

<script>
import confirm from "@/components/globalVue/Confirm.vue";
export default {
	name: "mediacontent",
	inject: ["picture_host"],
	props: {
		filters: {
			type: Object,
			default: () => {},
		},
		fromPage: {
			type: String,
			default: "posts",
		},
		moodboardSelectedColor: {
			type: Object,
			default: () => {},
		},
		moodboardSelectedBrands: {
			type: Array,
			default: () => [],
		},
		moodboardSelectedObjects: {
			type: Array,
			default: () => [],
		},
		moodboardModalHues: {
			type: Array,
			default: () => [],
		},
		moodboardModalSubHues: {
			type: Array,
			default: () => [],
		},
		moodboardModalBrands: {
			type: Array,
			default: () => [],
		},
		moodboardModalObjects: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			showModal: false,
			contentLoading: true,
			modalMedias: [],
			modalHues: [],
			modalSubHues: [],
			modalBrands: [],
			modalObjects: [],
			catsList: [],
			subcatsList: [],
			mastertagsList: [],
			mastertagsToAdd: [],
			postsByMastertag: {},
			catSelected: "",
			subcatSelected: "",
			mastertagSelected: "",
			mastertagsToRemove: [],
			modalType: "colors",
			totalCountHues: 0,
			selectedColor: {},
			selectedBrands: [],
			selectedObjects: [],
			selectedImages: [],
			nbPhotos: 96,
			categories: [],
			subcategories: [],
			mastertags: [],
			segments: [],
			allMastertags: [],
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
			groupBy: "medias",
			nbPhotosProfiles: 5,
			hiddenProfile: [],
		};
	},
	components: {
		confirm: confirm,
	},
	created() {
		this.$axios.get(this.$backendUrl + "postsVue").then((response) => {
			this.mastertags = response.data.mastertags;
			this.categories = response.data.categories;
			this.subcategories = response.data.subcategories;

			this.catsList = this.categories;
			this.subcatsList = this.subcategories;
			this.mastertagsList = this.mastertags;
		});
	},
	methods: {
		getName(media) {
			return media["pictures"]["buckets"][0]["tophits"]["hits"]["hits"][0]["_source"]["profile_name"];
		},
		getMediaId(media) {
			return media["tophits"]["hits"]["hits"][0]["_id"];
		},
		getMediaContent(media) {
			return media["tophits"]["hits"]["hits"][0]["_source"]["post_content"];
		},
		getMediaSource(media) {
			return media["tophits"]["hits"]["hits"][0]["_source"]["post_media"];
		},
		getMediaUrl(media) {
			return media["tophits"]["hits"]["hits"][0]["_source"]["post_url"];
		},
		getMediaPicture(media) {
			return media["tophits"]["hits"]["hits"][0]["_source"]["post_url"].replace("https://www.instagram.com/p/", "").replace("/", "");
		},
		getMediaStyle(media) {
			let picture = this.getMediaPicture(media);
			let profile_id = media["tophits"]["hits"]["hits"][0]["_source"]["profile_id"];

			if (media["tophits"]["hits"]["hits"][0]["_source"]["post_media"] === "instagram") {
				picture = this.picture_host + profile_id + "/source/" + picture + ".jpg";
			}

			return (
				"background-image:url(" +
				picture +
				");width: 184px;height: 184px;display: block;background-position: center;background-size: cover;"
			);
		},
		reloadModalContent(contentLoading = true) {
			this.hiddenProfile = [];
			this.contentLoading = contentLoading;
			let params = {
				parameters: this.filters,
				data: {
					selectedColor: this.selectedColor,
					selectedBrands: this.selectedBrands,
					selectedObjects: this.selectedObjects,
					nbPhotos: this.nbPhotos,
				},

				//modalType: this.modalType,
			};

			if (this.groupBy === "medias") {
				params.data.groupBy = this.groupBy;
				this.$axios.post(this.$backendUrl + "mediaContent", this.$Qs.stringify(params)).then((response) => {
					this.modalMedias = Object.values(response.data.results.pictures);
					if (Object.keys(this.selectedColor).length === 0) {
						this.modalHues = Object.values(response.data.results.hue);
					}
					this.totalCountHues = response.data.totalCountHues;

					this.modalBrands = Object.values(response.data.results.brands);
					this.modalObjects = Object.values(response.data.results.objects);
					this.contentLoading = false;
				});
			} else {
				params.data.groupBy = this.groupBy;
				params.data.nbPhotosProfiles = this.nbPhotosProfiles;
				this.$axios.post(this.$backendUrl + "mediaContent", this.$Qs.stringify(params)).then((response) => {
					this.modalMedias = Object.values(response.data.results.profiles);
					if (Object.keys(this.selectedColor).length === 0) {
						this.modalHues = Object.values(response.data.results.hue);
					}
					this.totalCountHues = response.data.totalCountHues;

					this.modalBrands = Object.values(response.data.results.brands);
					this.modalObjects = Object.values(response.data.results.objects);
					this.contentLoading = false;
				});
			}
		},
		loadModal(type = "") {
			if (type !== "") {
				this.modalType = type;
			}
			this.nbPhotos = 96;
			if (this.fromPage === "moodboard" && this.showModal === false) {
				if (typeof this.moodboardSelectedColor.type !== "undefined") {
					this.selectedColor = this.moodboardSelectedColor;
				}
				if (this.moodboardSelectedBrands.length > 0) {
					this.selectedBrands = JSON.parse(JSON.stringify(this.moodboardSelectedBrands));
				}
				if (this.moodboardSelectedObjects.length > 0) {
					this.selectedObjects = JSON.parse(JSON.stringify(this.moodboardSelectedObjects));
				}
				if (this.moodboardModalHues.length > 0) {
					this.modalHues = this.moodboardModalHues;
				}
				if (this.moodboardModalHues.length > 0) {
					this.modalSubHues = this.moodboardModalSubHues;
				}
				if (this.moodboardModalBrands.length > 0) {
					this.modalBrands = this.moodboardModalBrands;
				}
				if (this.moodboardModalObjects.length > 0) {
					this.modalObjects = this.moodboardModalObjects;
				}
			}

			this.reloadModalContent();
			this.showModal = true;
			setTimeout(() => {
				this.getNext();
			}, 1250);
		},
		hexToRgb(hex) {
			// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
			const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
			hex = hex.replace(shorthandRegex, function (m, r, g, b) {
				return r + r + g + g + b + b;
			});

			let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result
				? {
						r: parseInt(result[1], 16),
						g: parseInt(result[2], 16),
						b: parseInt(result[3], 16),
				  }
				: null;
		},
		resetTableColor() {
			this.selectedColor = {};
			this.selectedBrands = [];
			this.selectedObjects = [];
			this.selectedImages = [];
			this.modalSubHues = [];
			this.modalBrands = [];
			this.modalObjects = [];
			this.postsByMastertag = {};
			this.mastertagsToRemove = [];
			this.loadModal();
		},
		getTableColor(colorName, type) {
			this.selectedColor = {
				type: type,
				color: colorName,
			};
			this.loadModal();
		},
		getNext() {
			const listElm = document.querySelector("#media-modal-content .modal-body");
			listElm.addEventListener("scroll", () => {
				let scrollTop = listElm.scrollTop;
				let offsetHeight = listElm.offsetHeight;
				let scrollHeight = listElm.scrollHeight;

				if (scrollTop + offsetHeight === scrollHeight && scrollTop !== 0) {
					this.nbPhotos = this.nbPhotos + 96;
					this.reloadModalContent(false);
				}
			});
		},
		hueStyle(value) {
			let color = value["key"];
			return "background-color:" + color;
		},
		colorClicked(value, type) {
			this.getTableColor(value["key"], type);
			if (type === "hue") {
				this.modalSubHues = value["name"]["buckets"];
			}
		},
		clickOnArianeObjects(selectedObject) {
			this.selectedObjects.splice(this.selectedObjects.indexOf(selectedObject), 1);
			this.modalObjects = [];
		},
		clickOnArianeBrands(selectedBrand) {
			this.selectedBrands.splice(this.selectedBrands.indexOf(selectedBrand), 1);
			this.modalBrands = [];
		},
		onChangeBrands(e) {
			if (e.target.value !== "" && !this.selectedBrands.includes(e.target.value)) {
				this.selectedBrands.push(e.target.value);
			}
		},
		onChangeObjects(e) {
			if (e.target.value !== "" && !this.selectedObjects.includes(e.target.value)) {
				this.selectedObjects.push(e.target.value);
			}
		},
		addMedia(media, e) {
			e.target.parentNode.parentNode.classList.add("selected-image");
			e.target.parentNode.getElementsByClassName("btn-danger")[0].classList.add("btn-display");
			e.target.classList.remove("btn-display");
			this.selectedImages.push(media["key"]);

			let mastertags = media["tophits"]["hits"]["hits"][0]["_source"]["mastertags"];
			let post_id = media["tophits"]["hits"]["hits"][0]["_id"];

			for (let i = 0; i < mastertags.length; i++) {
				if (typeof this.postsByMastertag[mastertags[i]["label"]] === "undefined") {
					this.postsByMastertag[mastertags[i]["label"]] = [];
				}
				this.postsByMastertag[mastertags[i]["label"]].push(post_id);
			}
		},
		removeMedia(media, e) {
			e.target.parentNode.parentNode.classList.remove("selected-image");
			e.target.parentNode.getElementsByClassName("btn-success")[0].classList.add("btn-display");
			e.target.classList.remove("btn-display");
			let index = this.selectedImages.indexOf(media["key"]);
			if (index > -1) {
				this.selectedImages.splice(index, 1);
			}

			//let mastertags = media["tophits"]["hits"]["hits"][0]["_source"]["mastertags"];
			let post_id = media["tophits"]["hits"]["hits"][0]["_id"];

			for (let k in this.postsByMastertag) {
				let index = this.postsByMastertag[k].indexOf(post_id);
				if (index > -1) {
					this.postsByMastertag[k].splice(index, 1);
				}
				if (this.postsByMastertag[k].length === 0) {
					delete this.postsByMastertag[k];
				}
			}
		},
		listCatPosts(event, type) {
			let val = event.target.value;
			if (val !== "") {
				let params = { label: val, type: type };
				this.$axios
					.get(this.$backendUrl + "getCategory", {
						params: params,
						paramsSerializer: function (params) {
							return this.$Qs.stringify(params, {
								arrayFormat: "brackets",
							});
						},
					})
					.then((response) => {
						if (type === "cat") {
							this.subcatsList = response.data.category.subcategories;
							this.mastertagsList = response.data.mastertags;
						} else {
							this.mastertagsList = response.data.mastertags;
						}
					});
			} else {
				this.catsList = this.categories;
				this.subcatsList = this.subcategories;
				this.mastertagsList = this.mastertags;
			}
		},
		saveMassiveImages() {
			this.confirmLoadingModal("open");
			let mastertag = this.mastertagsToAdd;

			let data = {
				mastertag: mastertag,
				images: this.selectedImages,
			};

			if (mastertag && this.selectedImages.length > 0) {
				this.$axios.post(this.$backendUrl + "saveMassiveImages", this.$Qs.stringify(data)).then((response) => {
					if (response.data.return) {
						this.confirmSuccessModal("Images has been updated.");
						this.selectedImages = [];
						this.postsByMastertag = [];

						let docImages = document.getElementsByClassName("selected-image");
						while (docImages.length > 0) {
							docImages[0].getElementsByClassName("btn-danger")[0].classList.remove("btn-display");
							docImages[0].getElementsByClassName("btn-success")[0].classList.add("btn-display");
							docImages[0].classList.remove("selected-image");
						}
					}
				});
			} else {
				if (this.selectedImages.length === 0) this.confirmErrorModal("No Images selected");
				else {
					this.confirmErrorModal("Please select a mastertag");
				}
			}
		},
		removeMassiveImages() {
			this.confirmLoadingModal("open");
			let data = {
				mastertag: this.mastertagsToRemove,
				images: this.selectedImages,
			};

			if (this.mastertagsToRemove.length > 0 && this.selectedImages.length > 0) {
				this.$axios.post(this.$backendUrl + "deleteMastertagImages", this.$Qs.stringify(data)).then((response) => {
					if (response.data.return) {
						this.confirmSuccessModal("Mastertag removed from images.");

						let docImages = document.getElementsByClassName("selected-image");
						while (docImages.length > 0) {
							docImages[0].getElementsByClassName("btn-danger")[0].classList.remove("btn-display");
							docImages[0].getElementsByClassName("btn-success")[0].classList.add("btn-display");
							docImages[0].classList.remove("selected-image");
						}
					}
				});
			} else {
				if (this.selectedImages.length === 0) this.confirmErrorModal("No images selected");
				else {
					this.confirmErrorModal("Please select a mastertag");
				}
			}
		},
		selectMastertagsToRemove(mastertag, e) {
			let index = this.mastertagsToRemove.indexOf(mastertag);
			if (index > -1) {
				this.mastertagsToRemove.splice(index, 1);
				e.target.classList.remove("mastertag-selected");
			} else {
				this.mastertagsToRemove.push(mastertag);
				e.target.classList.add("mastertag-selected");
			}
		},
		removeMastertagToAdd(mastertag) {
			let index = this.mastertagsToAdd.indexOf(mastertag);
			if (index > -1) {
				this.mastertagsToAdd.splice(index, 1);
			}
		},
		toggleHideProfile(media) {
			let id = media["key"];
			if (this.hiddenProfile === 0) {
				this.hiddenProfile.push(id);
				return;
			}
			let index = this.hiddenProfile.indexOf(id);
			if (index === -1) {
				this.hiddenProfile.push(id);
			} else {
				this.hiddenProfile.splice(index, 1);
			}
		},
	},
	watch: {
		showModal: function () {
			if (this.showModal === false) {
				this.selectedColor = {};
				this.selectedBrands = [];
				this.selectedObjects = [];
				this.selectedImages = [];
				this.modalHues = [];
				this.modalSubHues = [];
				this.modalBrands = [];
				this.modalObjects = [];
				this.postsByMastertag = {};
				this.mastertagsToRemove = [];
				this.groupBy = "medias";
				this.nbPhotosProfiles = 5;
				this.hiddenProfile = [];
			}
		},
		selectedBrands: {
			handler() {
				if (this.showModal !== false) {
					this.loadModal();
				}
			},
			deep: true,
		},
		selectedObjects: {
			handler() {
				if (this.showModal !== false) {
					this.loadModal();
				}
			},
			deep: true,
		},
		groupBy: function () {
			if (this.showModal !== false) {
				this.loadModal();
			}
		},
		nbPhotosProfiles: function () {
			if (this.showModal !== false) {
				this.loadModal();
			}
		},
		mastertagSelected: function () {
			let index = this.mastertagsToAdd.indexOf(this.mastertagSelected);
			if (index === -1 && this.mastertagSelected.length > 0) {
				this.mastertagsToAdd.push(this.mastertagSelected);
			}
			this.mastertagSelected = "";
		},
	},
};
</script>

<style scoped>
.modal-body {
	min-height: 72vh;
	max-height: 72vh;
}

.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.close {
	outline: 0;
}

.dynvibeBox {
	min-height: 170px;
}

.dynvibeTitleModal {
	padding-bottom: 10px;
	margin-bottom: 0;
}

.dynvibeInputRadio input:checked {
	border-color: #33d1cd;
}

.dynvibeGalleryMedias {
	list-style: none;
}

.dynvibeGalleryMedias > li {
	display: inline-block;
}

.filterMedia {
	margin: 5px;
}

.dynvibeGalleryMediasFilter {
	position: absolute;
	top: 4px;
	width: 176px;
	height: 176px;
	display: none;
	background-color: rgba(35, 5, 107, 0.5);
}

.dynvibeGalleryMedias a:hover .dynvibeGalleryMediasFilter,
.imageSlider:hover .dynvibeGalleryMediasFilter {
	display: block;
}

.dynvibeGalleryMedias a:hover .dynvibeGalleryMediasHover,
.imageSlider:hover .dynvibeGalleryMediasHover {
	display: block;
}

.dynvibeGalleryMedias a:hover .dynvibeGalleryPopularMediasHover,
.imageSlider:hover .dynvibeGalleryPopularMediasHover {
	display: block;
}

.dynvibeGalleryMedias a {
	border: 4px solid white;
}

.dynvibeGalleryMedias a.selected-image {
	border: 4px solid #6ef132;
}

.dynvibeGalleryPopularMediasHover {
	display: none;
	position: absolute;
	top: 5%;
	width: 97%;
	text-align: center;
	text-transform: initial;
	color: #33d1cd;
	font-weight: 700;
	font-size: 12px;
	max-height: 93%;
	overflow: hidden;
}

.dynvibeGalleryPopularMediasHover button {
	display: none;
	font-weight: 700;
}

.dynvibeGalleryPopularMediasHover button.btn-display {
	display: block;
}

.filterMedia {
	float: left;
	list-style: none;
	position: relative;
	width: 176px;
	margin-right: 15px;
	margin-bottom: 10px;
}
</style>
<style scoped>
.dynvibeModalPostsActions {
	display: block;
}
.dynvibeModalPostsActionsAdd {
	display: block;
}

#hue-table,
#subhue-table {
	width: 100%;
	height: 55px;
}

#hue-table {
	margin-bottom: 10px;
}

#hue-table td,
#subhue-table td {
	cursor: pointer;
	text-align: center;
	font-weight: bold;
	border-right: 10px solid #fff;
}

#hue-table td:hover,
#subhue-table td:hover {
	opacity: 0.8;
}

#hue-table tr:first-child {
	height: 20px;
}

#subhue-table tr:last-child {
	height: 20px;
}

.reset-color {
	color: red;
	border: 1px solid red;
	background-color: transparent;
	margin-top: 5px;
}

.dynvibeSearch {
	border: none;
}

.dynvibeSearch #dynvibeSearchFiltersBase select {
	width: 100%;
}

.dynvibeModalPostsActionsFooterBtn {
	width: 100%;
	display: block;
	padding: 7px 7px;
}
.dynvibeModalPostsActionsFooterBtn:first-child {
	margin-bottom: 5px;
}

.dynvibeModalPostsActions {
	border: none;
	text-align: left;
	padding: 0px;
}

.menuAriane {
	display: flex;
	align-items: center;
	height: 20px;
	min-width: 150px;
	padding: 0px 4px 0px 7px;
	margin-right: 10px;
	border-radius: 12px;
	font-size: 13px;
	font-weight: 700;
	text-transform: uppercase;
	cursor: pointer;
	margin-top: auto;
	margin-left: auto;
}

.menuArianeAdd {
	display: inline-block;
	color: #33d1cd;
	border: 1px solid #33d1cd;
}

.menuAriane i {
	font-size: 6px;
	padding: 4px;
	margin-left: auto;
	border-radius: 50%;
}

.menuArianeValue {
	margin-right: 20px;
}

.menuArianeBrand {
	color: #ef402e;
	border: 1px solid #ef402e;
	margin-bottom: 5px;
}

.menuArianeBrand i {
	color: #fff;
	background-color: #ef402e;
}

.menuArianeObject {
	color: #33d1cd;
	border: 1px solid #33d1cd;
	margin-bottom: 5px;
}

.menuArianeObject i {
	color: #fff;
	background-color: #33d1cd;
}

.menuMastertagToAdd i {
	color: #fff;
	background-color: #33d1cd;
}

.mastertag-selected {
	background-color: #e30f0f;
	color: #fff;
}
.dynvibeStoryInfoUsername {
	display: inline-block;
	margin-right: 20px;
}
.mediasByAuthor {
	margin-bottom: 15px;
}
</style>
